import "core-js/modules/es6.string.starts-with";
//
//
//
//
//
//
//
//
//
//
//
//
//

import pathToRegexp from "path-to-regexp";
export default {
  data: function data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route: function $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created: function created() {
    this.getBreadcrumb();
  },
  methods: {
    back: function back() {
      if (this.$route.path.indexOf("workbench") === -1) {
        window.history.back();
      }
    },
    getBreadcrumb: function getBreadcrumb() {
      // only show routes with meta.title
      var matched = this.$route.matched.filter(function (item) {
        return item.meta && item.meta.title;
      });
      var first = matched[0];
      if (!this.isDashboard(first)) {
        matched = [{
          path: "/workbench",
          meta: {
            title: "工作台"
          }
        }].concat(matched);
      }
      this.levelList = matched.filter(function (item) {
        return item.meta && item.meta.title && item.meta.breadcrumb !== false;
      });
    },
    //判断是否是首页
    isDashboard: function isDashboard(route) {
      var name = route && route.path;
      if (!name) {
        return false;
      }
      return (
        //name.trim().toLocaleLowerCase() === "workbenchschoolss".toLocaleLowerCase()
        name.indexOf("workbench") !== -1
      );
    },
    pathCompile: function pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      var params = this.$route.params;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink: function handleLink(item) {
      var redirect = item.redirect,
        path = item.path;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    }
  }
};